// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2qj3Z","label":"Completed_label__HIDdK"};